import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from '../../sidenav/sidenav.service';
import { PlatformGlobalService } from '../../service/platform-global.service';
import { DashboardService } from 'src/app/pages/dashboard/service/dashboard.service';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';

@Component({
  selector: 'prep-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
})
export class ToolbarUserComponent implements OnInit {
  @ViewChild('triggerBtn', { read: ElementRef }) triggerBtn: ElementRef;
  @ViewChild('menuPanel') menuPanel: ElementRef;

  isOpen: boolean;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;
  constructor(
    private router: Router,
    private platformGlobalService: PlatformGlobalService,
    private dashboardService: DashboardService,
    private sidenavService: SidenavService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpen) {
      this.closeAndReturnFocus();
    }
  }

  ngOnInit() { }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.focusItemByIndex(0));
    }
  }

  onClickOutside() {
    this.isOpen = false;
  }

  closeAndReturnFocus() {
    this.isOpen = false;
    this.triggerBtn?.nativeElement?.focus();
  }

  onMenuKeydown(event: KeyboardEvent) {
    const items = this.getMenuItems();
    if (items.length === 0) return;
    const current = items.indexOf(document.activeElement as HTMLElement);

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.focusItem(items, current < items.length - 1 ? current + 1 : 0);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.focusItem(items, current > 0 ? current - 1 : items.length - 1);
        break;
      case 'Home':
        event.preventDefault();
        this.focusItem(items, 0);
        break;
      case 'End':
        event.preventDefault();
        this.focusItem(items, items.length - 1);
        break;
      case 'Tab':
        this.closeAndReturnFocus();
        break;
    }
  }

  private getMenuItems(): HTMLElement[] {
    const panel = this.menuPanel?.nativeElement;
    if (!panel) return [];
    return Array.from(panel.querySelectorAll('[role="menuitem"]'));
  }

  private focusItem(items: HTMLElement[], index: number) {
    items.forEach(el => el.setAttribute('tabindex', '-1'));
    items[index]?.setAttribute('tabindex', '0');
    items[index]?.focus();
  }

  private focusItemByIndex(index: number) {
    const items = this.getMenuItems();
    if (items.length > 0) {
      this.focusItem(items, index);
    }
  }

  logoutClicked() {
    console.log('User Info toolbar', this.platformGlobalService.getCUserinfo);
    if (this.platformGlobalService.getCUserinfo.email) {
      const accEmail = this.platformGlobalService.getCUserinfo.email;
      const accDomain = accEmail.replace(/.*@/, "");
      console.log("Domain Info", accDomain);
      if (accDomain === 'stanford.edu') {
        localStorage.removeItem('token');
        localStorage.removeItem('account');
        this.sidenavService.items = [];
        window.location.replace('https://stanford.prep.continualengine.com/login');
      } else {
        let sendUserInfo = {
          username: this.platformGlobalService.getCUserinfo.email,
        };

        this.dashboardService.logoutCuncurrentUser(sendUserInfo).subscribe(
          (response) => {
            if (response.msg) {
              localStorage.removeItem('token');
              localStorage.removeItem('account');
              this.sidenavService.items = [];
              this.router.navigate(['/login']);
            }
          },
          (error) => {
            console.log('error', error);
            localStorage.removeItem('token');
            localStorage.removeItem('account');
            this.sidenavService.items = [];
            this.router.navigate(['/login']);
          }
        );
      }
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('account');
      this.sidenavService.items = [];
      this.router.navigate(['/login']);
    }
  }
  profile() {
    console.log('welcome to profile');
    this.router.navigate(['/profile']);
  }

}
